import { isNavigationFailure } from 'vue-router';

export default function legacyNavigation(router) {
  // Vue Router 3.1+ returns rejecting Promises where 3.0 used callbacks only.
  // Redirect/cancel/duplicate are control flow; unexpected errors still reject.
  ['push', 'replace'].forEach(method => {
    const navigate = router[method].bind(router);
    router[method] = (location, onComplete, onAbort) => {
      const result = navigate(location, onComplete, onAbort);
      return result && typeof result.catch === 'function'
        ? result.catch(error => {
            if (isNavigationFailure(error)) return router.currentRoute;
            throw error;
          })
        : result;
    };
  });
  return router;
}
